///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../abstract-command';
import { ActivityDTO } from '../../../../../services/project-socket/activity-dto.model';
import { GtthStepGroupEnum, ProjectUserSessionDTO } from '../../../../../generated/shared-types.model';

export class GtthApplyUserSessionCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthApplyUserSessionCommand';
    }

    doCommand(): void {
        const activity = this.createActivityDTO(false);
        this.sendActivity(activity);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful || !activityDto.userSession) {
            this.commandResolve(false);
            return;
        }

        this.applyChanges(activityDto.userSession);
        this.commandResolve(true);
    }

    private applyChanges(userSession: ProjectUserSessionDTO): void {
        this.historyService.projectUserSessionService.loadSessionObject(userSession);

        this.historyService.polygonsService.isShowStoredPolygons = userSession.showStoredPolygons;

        if (
            this.historyService.projectStateService.isBomConfigProject() ||
            this.historyService.projectStateService.isPotentiallyCorruptedProject()
        ) {
            userSession.stepGroupNumber = GtthStepGroupEnum.PLAN_AND_OPTIMISE;
        }

        this.historyService.selectedStepNumber = userSession.stepGroupNumber;
    }
}
